export const medicationFieldNames = {
  rxnormDrug: "rxnormDrug",
  physician: "physician",
  dosageDisplay: "dosageDisplay",
  dosageValue: "dosageValue",
  dosageUnit: "dosageUnit",
  currentCycle: "currentCycle",
  nextAdminDate: "nextAdminDate"
};
export const ivMedicationFields = { quantity: "quantity", numOfCycles: "numOfCycles" };
export const nonIvMedicationFields = {
  frequency: "frequency",
  numberOfRefillsAuthorized: "numberOfRefillsAuthorized",
  quantityValue: "quantityValue"
};
